import axios from "axios";
import config from "@/config";


export function isCheckRole(path) {


        const formData = new FormData();
        formData.append('role_group', path.matched[0].path.replace('/', ''));
        formData.append('role_page', path.path);

         axios.post(config.baseURLApi + '/api/getRoleUserWeb', formData).
        then(res => {

             if (Object.keys(res.data).length!=0){
                 return true
             }
             else {
                 return false
             }

        });



return path;
}

export const RoleMixin = {
    methods: {
        isCheckRole,
    },
};
